import { ChangeDetectionStrategy, Component, input, model, output, TemplateRef } from '@angular/core';
import { TreeviewConfig } from 'src/app/bo/treeview/treeview-config';
import { TreeviewItem } from 'src/app/bo/treeview/treeview-item';
import { TreeviewItemTemplateContext } from 'src/app/bo/treeview/treeview-item-template-context';

@Component({
  selector: 'app-treeview-item',
  templateUrl: './treeview-item.component.html',
  styleUrls: ['./treeview-item.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TreeviewItemComponent {
  readonly config = input<TreeviewConfig>();
  readonly template = input<TemplateRef<TreeviewItemTemplateContext>>();
  readonly item = input<TreeviewItem>();
  readonly parent = input<TreeviewItem>();
  readonly checkedChange = output<boolean>();

  
  tirNameLocal = '';

  constructor(private readonly defaultConfig: TreeviewConfig) {
    if (!this.config()) {
      // Apply default config if none provided
    }
  }

  onCollapseExpand = () => {
    const item = this.item();
    if (item) {
      item.collapsed = !item.collapsed;
    }
  }

  onCheckedChange = (tirName:string = null) => {
    const item = this.item();
    if (!item) return;
    
    let checked = item.checked;
   
   if(tirName != null && checked){
     this.tirNameLocal = tirName;
   }

   if(tirName != null && checked && this.tirNameLocal === tirName ){
    return
   } 
   
   if (tirName != null) {
     checked = true;
     item.checked = true;
     this.tirNameLocal = tirName;
   }
    
  const config = this.config() || this.defaultConfig;
  if (item.children !== null && item.children !== undefined && !config.decoupleChildFromParent) {
    item.children.forEach(child => child.setCheckedRecursive(checked));
  }
  
  this.checkedChange.emit(checked);
  }

  onChildCheckedChange(child: TreeviewItem, checked: boolean): void {
    const item = this.item();
    const config = this.config() || this.defaultConfig;
    
    if (!item || !config || config.decoupleChildFromParent) {
      this.checkedChange.emit(checked);
      return;
    }
    
    let itemChecked: boolean = null;
    for (const childItem of item.children) {
      if (itemChecked === null) {
        itemChecked = childItem.checked;
      } else if (itemChecked !== childItem.checked) {
        itemChecked = undefined;
        break;
      }
    }

    if (itemChecked === null) {
      itemChecked = false;
    }

    if (item.checked !== itemChecked) {
      item.checked = itemChecked;
    }

    this.checkedChange.emit(checked);
  }
}
